/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OtaService {
  /**
   * 新增 - 上传软件包
   * @param formData
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgUpload(formData) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/upload',
      formData: formData,
      mediaType: 'multipart/form-data'
    });
  }
  /**
   * 新增 - 保存
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgSave(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/save',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 已部署节点 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgDeployed(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/deployed',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 创建部署任务
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgDeploy(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/deploy',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 节点列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgDeployNode(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/deploy/node',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaPkgRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/pkg/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 节点总数 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployNodeList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/node/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 节点总数 - 重新部署
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployNodeRenew(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/node/renew',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 节点总数 - 详情
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployNodeDetail(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/node/detail',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 节点总数 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployNodeRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/node/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 编辑
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postOtaDeployEdit(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ota/deploy/edit',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
}